import dark1 from '../assets/dark/dark-1.png'
import dark2 from '../assets/dark/dark-2.png'
import dark3 from '../assets/dark/dark-3.png'
import dark4 from '../assets/dark/dark-4.png'
import dark5 from '../assets/dark/dark-5.png'
import dark6 from '../assets/dark/dark-6.png'

import light1 from '../assets/light/light-1.png'
import light2 from '../assets/light/light-2.png'
import light3 from '../assets/light/light-3.png'
import light4 from '../assets/light/light-4.png'
import light5 from '../assets/light/light-5.png'
import light6 from '../assets/light/light-6.png'

export const fallbackImages = {
  dark: [dark1, dark2, dark3, dark4, dark5, dark6],
  light: [light1, light2, light3, light4, light5, light6],
} as const

export type ImageTheme = keyof typeof fallbackImages

/**
 * Gets the next available image index ensuring no two adjacent cards use the same fallback image.
 *
 * Maps card indices to image indices using modulo. If current matches previous, shifts to next image.
 *
 * @param currentIndex - The index of the current card (0, 1, 2, ...)
 * @param previousIndex - The index of the previous card (-1 if no previous card)
 * @param totalImages - The total number of available fallback images
 * @returns The image index to use for the current card
 */
export function getNextAvailableImageIndex(currentIndex: number, previousIndex: number, totalImages: number): number {
  const currentIdx = currentIndex % totalImages
  const prevIdx = previousIndex < 0 ? -1 : previousIndex % totalImages

  return currentIdx === prevIdx ? (currentIdx + 1) % totalImages : currentIdx
}

export function getFallbackImageUrl(index = 0, theme: ImageTheme = 'light'): string {
  const images = fallbackImages[theme]
  const fallbackIndex = getNextAvailableImageIndex(index, index - 1, images.length)
  return images[fallbackIndex] || '/images/modules/site/contentful/default/md.webp'
}
